




































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import TotalsChart from "../components/TotalsChart.vue";
import {
  MonthTotalDataItem,
  TopDataItem,
  DistroDataSet,
  CountryTotalDataItem,
  Filter
} from "@/classes/DistroDataSet";
import TopWidget from "@/components/TopWidget.vue";
import TotalsMap from "@/components/TotalsMap.vue";
import TotalWidget from "@/components/TotalWidget.vue";

@Component({
  components: {
    "totals-chart": TotalsChart,
    "totals-map": TotalsMap,
    "top-widget": TopWidget,
    "total-widget": TotalWidget
  }
})
export default class Overview extends Vue {
  @Prop() public dataSet!: DistroDataSet;
  @Prop() public datesFilter!: Date[];

  monthlyTotals: MonthTotalDataItem[] = [];
  countryTotals: CountryTotalDataItem[] = [];
  topReleasesByRevenue: TopDataItem[] = [];
  topCountriesByRevenue: TopDataItem[] = [];
  topStoresByRevenue: TopDataItem[] = [];
  topArtistsByRevenue: TopDataItem[] = [];
  totalEarnings = 0;

  mounted() {
    this.setData();
  }

  @Watch("datesFilter")
  setData() {
    const [fromDate, toDate] = this.$props.datesFilter;
    const filter: Filter = {
      fromDate: fromDate,
      toDate: toDate
    };
    this.monthlyTotals = this.$props.dataSet.getMonthTotals(filter);
    this.countryTotals = this.$props.dataSet.getCountryTotals(filter);
    this.topReleasesByRevenue = this.$props.dataSet.getTopReleasesByRevenue(
      filter
    );
    this.topCountriesByRevenue = this.$props.dataSet.getTopCountriesByRevenue(
      filter
    );
    this.topStoresByRevenue = this.$props.dataSet.getTopStoresByRevenue(filter);
    this.topArtistsByRevenue = this.$props.dataSet.getTopArtistsByRevenue(
      filter
    );
    this.totalEarnings = this.$props.dataSet.getTotalEarnings(filter);
  }
}
